import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';

import { useGetRecord } from 'root/admin/components/hooks';
import { Title } from 'root/admin/components';

import store from 'root/admin/store';
import { Form, Field, Loader, Attachments } from '@smartplatform/ui';

const ArticleEdit = ({ match, rootPath, tabName }) => {
	const { id } = match.params;
	const options = {};
	const record = useGetRecord({ model: 'Bill', id, options, tabName });
	const [showAttachments, setShowAttachments] = useState();

	useEffect(() => {
		if (record && record.id) {
			setShowAttachments(true);
		}
	}, [record]);

	if (!record) {
		return <Loader />;
	}

	if (record && !record.id) {
		record.publishAt = new Date();
	}

	const onSave = () => {
		if (isNaN(id)) {
			store.history.push(`${rootPath}/bills/${record.id}`);
		} else {
			store.history.push(`${rootPath}/bills`);
		}
	};

	console.log(record);

	return (
		<div>
			<Title record={record} name="Закон" />
			<Form record={record} rootPath={rootPath} stay={!record.id} onSave={onSave}>
				<Field property="name" label="Название" />
				<Field relation="type" label="Тип" property="name" />
				<Field relation="additional" property="name" label="Долнительно" />
				<Field relation="theme" property="name" label="Тематический блок" />
				<Field relation="committee" property="name" label="Ответственный комитет" />
				<Field relation="status" property="name" label="Статус" />
				{showAttachments ? (
					<Field label="Документы">
						<Attachments
							record={record}
							store={store.model}
							accept="application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf, application/zip, application/x-rar-compressed"
						/>
					</Field>
				) : (
					<p>Создайте Закон для добавления документов </p>
				)}
			</Form>
		</div>
	);
};

export default withRouter(ArticleEdit);
